import { createLucideIcon } from 'lucide-react';

export const CircleHalfFilled = createLucideIcon('CircleHalfFilled', [
  [
    'path',
    {
      key: 'path-1',
      d: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M1 12a11 11 0 1 1 22 0 11 11 0 0 1-22 0',
      fill: 'currentColor',
      stroke: 'none',
    },
  ],
  [
    'path',
    {
      key: 'path-2',
      d: 'M11.8 5.8q.2-.3.6-.3a6 6 0 0 1 4.3 1.9 7 7 0 0 1 1.8 4.6q0 2.7-1.8 4.6a6 6 0 0 1-4.3 1.9q-.8 0-.9-1v-11q0-.5.3-.7',
      fill: 'currentColor',
      stroke: 'none',
    },
  ],
]);
